import React, { useMemo, useState } from 'react';
import styled from 'styled-components/macro';
import { updateVisualStudio } from '../../constants/urls';
import { ResourceStrings } from '../../ResourceStrings';
import { ReleaseAction, ReleaseActionInfo } from '../../store/appState';
import Button from './Button';
import OutdatedBuildBlockDialog from './OutdatedBuildDialog';

export interface OutdatedBuildBannerProps {
  releaseActionInfo: ReleaseActionInfo;
}

export default function OutdatedBuildBanner(props: OutdatedBuildBannerProps): JSX.Element {
  const [showBlockingDialog, setShowBlockingDialog] = useState(false);

  const dialogText = useMemo(() => {
    if (props.releaseActionInfo.isPreview) {
      if (props.releaseActionInfo.action === ReleaseAction.Block) {
        return ResourceStrings.outdatedBuildBlockPreviewBanner(props.releaseActionInfo.edition, props.releaseActionInfo.brand);
      }
      if (props.releaseActionInfo.action === ReleaseAction.Warn) {
        return ResourceStrings.outdatedBuildWarnPreviewBanner(props.releaseActionInfo.edition, props.releaseActionInfo.brand);
      }
      return ResourceStrings.outdatedBuildNotifyBanner(props.releaseActionInfo.edition, props.releaseActionInfo.brand);
    }
    else {
      if (props.releaseActionInfo.action === ReleaseAction.Block) {
        return ResourceStrings.outdatedBuildBlockBanner(props.releaseActionInfo.edition, props.releaseActionInfo.brand);
      }
      if (props.releaseActionInfo.action === ReleaseAction.Warn) {
        return ResourceStrings.outdatedBuildWarnBanner(props.releaseActionInfo.edition, props.releaseActionInfo.brand);
      }
      return ResourceStrings.outdatedBuildNotifyBanner(props.releaseActionInfo.edition, props.releaseActionInfo.brand);
    }
  }, [props.releaseActionInfo.action]);

  return <>
    <Wrapper>
      <span>{dialogText}</span>
      <Button onClick={() => { window.open(updateVisualStudio, "_blank") }}>Update Visual Studio</Button>
      <Button onClick={() => { setShowBlockingDialog(true) }}>More Info</Button>
    </Wrapper>
    <OutdatedBuildBlockDialog
        releaseActionInfo={props.releaseActionInfo}
        isOpen={showBlockingDialog}
        showContinueButton={false}
        onClose={() => setShowBlockingDialog(false)}
      />
  </>
}

const Wrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: baseline;
    background-color: var(--color-warning);
    color: var(--color-on-primary);
    font-size: 1.9rem;
    padding: .8rem 2rem;

    &&> button {
        background-color: var(--color-surface);
        color: var(--color-on-surface-link);
        font-size: 1.8rem;
        font-weight: 600;
        margin-left: 1.5rem;
        border: none;
        padding: 1rem
    }

    &&> button:hover {
        background-color: var(--color-surface);
        color: var(--color-on-surface-link);
    }
`;
